import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { BAG_STATUS, getPaxsTotalBags } from '@bagonboard/wiseman';

import placeholder from '../../../../../../../assets/img/placeholder.jpg';
import * as actions from '../../../../../../../reducers/Service/actions';
import {
  Bag, BagImage, Column, Delete, Span, Status, Text,
} from './style';

const { TO_PICKUP } = BAG_STATUS;

class PassengerBags extends Component {
  state = {
    hover: false,
  };

  onDeleteClick = () => {
    const {
      bag, id, pax, paxs, updateService,
    } = this.props;
    const newPaxs = paxs.map(item => ({
      ...item,
      _id    : undefined,
      bags   : item._id === pax._id ? item.bags.filter(i => i._id !== bag._id) : item.bags,
      numBags: item._id === pax._id && item.numBags > 0 ? item.numBags - 1 : item.numBags,
    }));

    const totalBags = getPaxsTotalBags(paxs);
    updateService({ bags: totalBags - 1, paxs: newPaxs, serviceId: id });
  };

  activateHover = () => {
    this.setState({ hover: true });
  }

  deactivateHover = () => {
    this.setState({ hover: false });
  }

  render() {
    const { bag, bagPhotos, details } = this.props;
    const { hover } = this.state;

    return (
      <Bag onMouseEnter={this.activateHover} onMouseLeave={this.deactivateHover}>
        <BagImage src={bagPhotos.bagPickup || placeholder} alt="User Id" />
        <Column>
          <Status color={details.color}>{details.text}</Status>
          <Text>
            <Span>Bag</Span>
            {bag.code}
          </Text>
        </Column>
        {hover && bag.status === TO_PICKUP && <Delete onClick={this.onDeleteClick} />}
      </Bag>
    );
  }
}

PassengerBags.propTypes = {
  bag          : PropTypes.shape({}),
  bagPhotos    : PropTypes.shape({}),
  details      : PropTypes.shape({}),
  id           : PropTypes.string,
  pax          : PropTypes.shape({}),
  paxs         : PropTypes.arrayOf(PropTypes.shape({})),
  updateService: PropTypes.func,
};

PassengerBags.defaultProps = {
  bag      : {},
  bagPhotos: {},
  details  : {},
  id       : '',
  pax      : {
    bags        : [],
    name        : '',
    numBags     : 0,
    photos      : {},
    seatNumber  : '',
    surname     : '',
    ticketNumber: '',
  },
  paxs: [],
  updateService() {},
};

const mapDispatchToProps = dispatch => ({
  updateService: data => dispatch(actions.updateService(data)),
});

export default compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(PassengerBags);
